export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-500italic-07d7b0bb5968c342e047a0f736f37a69.ttf";